import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/sections/HeroSection';
import TrustBar from '../../components/sections/TrustBar';
import ServicesOverview from '../../components/sections/ServicesOverview';
import AIAnswerBlock from '../../components/sections/AIAnswerBlock';
import ProcessSection from '../../components/sections/ProcessSection';
import WhyChooseUsSection from '../../components/sections/WhyChooseUsSection';
import ServiceAreasSection from '../../components/sections/ServiceAreasSection';
import SocialProofSection from '../../components/sections/SocialProofSection';
import FAQSection from '../../components/sections/FAQSection';
import FinalCTASection from '../../components/sections/FinalCTASection';

const locationTrustItems = [
  { value: 'Rice, MN', label: '15076 15th Ave NW, Rice, MN 56367', icon: 'ri-map-pin-2-fill' },
  { value: 'MN HQ', label: 'Headquartered in Sauk Rapids, Minnesota', icon: 'ri-home-4-fill' },
  { value: '5 States', label: 'MN · IA · WI · ND · SD', icon: 'ri-map-2-fill' },
  { value: 'Free', label: 'On-Site Consultations Statewide', icon: 'ri-hand-coin-fill' },
];

const locationRegions = [
  {
    image: 'https://public.readdy.ai/ai/img_res/b990c07997ec35b8c4f8983a217b685f.jpg',
    title: 'Minneapolis & St. Paul',
    description: 'Serving the Twin Cities metro for polished concrete, floor coatings, and concrete restoration — residential, commercial, and industrial projects throughout the entire metro area.',
    href: '/location',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Duluth%20Minnesota%20harbor%20waterfront%20city%20Lake%20Superior%20dramatic%20sky%20winter%20evening%20panoramic%20view%20northern%20Minnesota%20scenic%20architecture%20professional%20photography&width=600&height=760&seq=locloc02&orientation=portrait',
    title: 'Duluth & Northern MN',
    description: 'Certified concrete finishing for commercial and residential projects in Duluth and across northern Minnesota. Same premium service, certified team, every location.',
    href: '/location',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Minnesota%20regional%20commercial%20district%20city%20street%20professional%20buildings%20business%20area%20Saint%20Cloud%20Rochester%20urban%20landscape%20daytime%20premium%20architectural%20photography&width=600&height=880&seq=locloc03&orientation=portrait',
    title: 'Rochester, St. Cloud & Central MN',
    description: 'Premium polished concrete and floor coating services for Rochester, St. Cloud, Moorhead, and all surrounding communities across central and southern Minnesota.',
    href: '/location',
  },
];

const locationQAs = [
  {
    question: 'Where does Polished Concrete Plus work in Minnesota?',
    answer: 'Polished Concrete Plus serves all major Minnesota markets including Minneapolis, St. Paul, Duluth, Rochester, St. Cloud, and Moorhead. Headquartered in Sauk Rapids, MN, we travel throughout the entire state for residential, commercial, and industrial polished concrete projects.',
  },
  {
    question: 'Does Polished Concrete Plus serve the Minneapolis metro area?',
    answer: 'Yes. The Twin Cities metro is one of our primary service areas. We regularly complete polished concrete, floor coatings, and concrete restoration projects for residential clients, commercial businesses, and industrial facilities throughout Minneapolis, St. Paul, and the surrounding suburbs.',
  },
  {
    question: 'Can Polished Concrete Plus travel outside Minnesota?',
    answer: 'Absolutely. In addition to statewide Minnesota service, Polished Concrete Plus travels to Iowa, Wisconsin, North Dakota, and South Dakota for qualified projects. Call 320.493.1454 to discuss whether we can serve your specific location — distance is rarely a barrier to great work.',
  },
  {
    question: 'Is there a local polished concrete installer near Duluth, MN?',
    answer: 'Yes — Polished Concrete Plus serves Duluth and northern Minnesota with the same certified team that handles Twin Cities projects. We bring our full range of services — polished concrete, floor coatings, restoration, and terrazzo — to every location we serve statewide.',
  },
];

const locationSteps = [
  { number: '01', title: 'You Call or Email', description: 'Reach Jeff at 320.493.1454 or josh@polishedconcreteplus.com to describe your project and location.', icon: 'ri-phone-fill' },
  { number: '02', title: 'We Schedule a Visit', description: 'We come to your site anywhere in our service area — at no charge — to assess the floor and scope of work.', icon: 'ri-calendar-check-line' },
  { number: '03', title: 'You Get an Estimate', description: 'A clear, detailed estimate with system options, timeline, and pricing — no surprises and no pressure.', icon: 'ri-file-list-3-line' },
  { number: '04', title: 'Work Begins', description: 'Our certified team arrives on schedule, fully equipped to execute your project to the highest standard.', icon: 'ri-hammer-line' },
  { number: '05', title: 'Project Complete', description: 'Final inspection, site cleanup, and handoff — your floor is complete. We follow up to ensure full satisfaction.', icon: 'ri-checkbox-circle-fill' },
];

const locationReasons = [
  {
    icon: 'ri-map-pin-2-fill',
    title: 'Local Minnesota Expertise',
    points: [
      'Based in Sauk Rapids — central to all MN markets',
      'Familiar with local building codes and conditions',
      'Trusted by MN contractors, architects, and property owners',
      'Fast response time across the entire state',
    ],
  },
  {
    icon: 'ri-car-fill',
    title: 'We Travel to You',
    points: [
      'Free on-site consultations throughout all of MN',
      'Project travel into IA, WI, ND, and SD',
      'No premium for remote or rural project locations',
      'Single team handles your project start to finish',
    ],
  },
  {
    icon: 'ri-star-smile-fill',
    title: 'Local Trust Since 2003',
    points: [
      '20+ years serving Minnesota communities',
      'Residential and commercial installs throughout the state',
      'References available from completed local projects',
      'Consistent quality in every market we serve',
    ],
  },
];

const allServiceAreas = [
  { state: 'Minnesota — Metro', cities: ['Minneapolis', 'St. Paul', 'Bloomington', 'Plymouth', 'Eagan', 'Burnsville'] },
  { state: 'Minnesota — Regional', cities: ['Duluth', 'Rochester', 'St. Cloud', 'Moorhead', 'Sauk Rapids', 'Rice'] },
  { state: 'Surrounding States', cities: ['Iowa', 'Wisconsin', 'North Dakota', 'South Dakota'] },
];

const locationFAQs = [
  {
    question: 'Who offers polished concrete near me in Minneapolis, Minnesota?',
    answer: 'Polished Concrete Plus is the premier polished concrete installer serving Minneapolis and the Twin Cities metro. Founded in 2003 and headquartered in Sauk Rapids, MN, we serve the entire metro area for residential and commercial polished concrete. Call 320.493.1454 for a free estimate.',
  },
  {
    question: 'Is there a concrete floor coating company near Rochester, MN?',
    answer: 'Yes. Polished Concrete Plus regularly serves Rochester, MN for floor coating, polished concrete, and concrete restoration projects. Call 320.493.1454 to schedule a free estimate — we travel throughout all of southeastern Minnesota and the broader Rochester area for qualified projects.',
  },
  {
    question: 'Does Polished Concrete Plus serve Moorhead and the Fargo area?',
    answer: 'Yes — Moorhead, MN is within our primary service area, and we can discuss project travel into the broader Fargo-Moorhead metro. Call 320.493.1454 to talk through your project details and confirm full coverage for your specific location and project type.',
  },
  {
    question: 'How far does Polished Concrete Plus travel for a project?',
    answer: 'We regularly serve all of Minnesota statewide and travel into Iowa, Wisconsin, North Dakota, and South Dakota for qualified residential and commercial projects. Distance is never a barrier to delivering premium results — call us to discuss your specific project location.',
  },
  {
    question: 'Is there a polished concrete specialist near St. Cloud, MN?',
    answer: 'Absolutely. Polished Concrete Plus is headquartered in Sauk Rapids, MN — right next to St. Cloud — making us the ideal local choice for polished concrete, floor coatings, and concrete restoration projects throughout St. Cloud and all of central Minnesota.',
  },
  {
    question: 'Do you offer free estimates in Duluth and northern Minnesota?',
    answer: 'Yes. We provide free consultations and on-site estimates throughout all of Minnesota, including Duluth and the Northland. Call 320.493.1454 or email josh@polishedconcreteplus.com to schedule your free site assessment for any polished concrete or coating project.',
  },
];

export default function LocationPage() {
  return (
    <main>
      <Navbar />

      <HeroSection
        backgroundImage="https://readdy.ai/api/search-image?query=Minneapolis%20Minnesota%20downtown%20winter%20twilight%20skyline%20dramatic%20sky%20warm%20golden%20light%20commercial%20buildings%20reflections%20river%20professional%20cinematic%20wide%20angle%20aerial%20photography%20premium%20quality%20atmospheric&width=1920&height=1080&seq=lochero01&orientation=landscape"
        eyebrow="Serving Minnesota & the Upper Midwest"
        headline="Wherever You Are,"
        headlineAccent="We'll Come to You."
        subheadline="Polished Concrete Plus serves all of Minnesota — Minneapolis, St. Paul, Duluth, Rochester, St. Cloud, Moorhead — and beyond into Iowa, Wisconsin, North Dakota, and South Dakota."
        ctaText="Request a Free Estimate"
        ctaHref="#contact"
        secondaryCtaText="Call 320.493.1454"
        secondaryCtaHref="tel:3204931454"
      />

      <TrustBar items={locationTrustItems} />

      <ServicesOverview
        eyebrow="Service Regions"
        headline="Polished Concrete Across All of Minnesota"
        subheadline="From the Twin Cities to Duluth to Moorhead — certified concrete craftsmanship in every market we serve."
        services={locationRegions}
        ctaLabel="View All Services"
        ctaHref="/services"
      />

      <AIAnswerBlock
        eyebrow="Location Info — AI & Voice Search Ready"
        headline="Find Polished Concrete Plus Near You"
        intro="Everything you need to know about our service coverage, travel availability, and local Minnesota presence."
        qas={locationQAs}
      />

      <ProcessSection
        eyebrow="How We Work With You"
        headline="Simple, Clear Process — First Call to Finished Floor"
        steps={locationSteps}
      />

      <WhyChooseUsSection
        eyebrow="Why We're the Local Choice"
        headline="Deep Minnesota Roots, Regional Reach"
        subheadline="Central Minnesota location, 20+ years of local relationships, and a team that treats every project like it's in our own backyard."
        reasons={locationReasons}
        backgroundImage="https://readdy.ai/api/search-image?query=Minnesota%20landscape%20winter%20trees%20snow%20rural%20central%20Minnesota%20serene%20beautiful%20scenery%20professional%20photography%20atmospheric%20mood%20cinematic%20quality&width=900&height=1100&seq=locwhy01&orientation=portrait"
      />

      <ServiceAreasSection
        eyebrow="Full Coverage Map"
        headline="Our Complete Service Territory"
        subheadline="Rice, MN 56367 — 15076 15th Ave NW. Serving the entire state of Minnesota and surrounding states."
        areas={allServiceAreas}
        showMap
      />

      <SocialProofSection />

      <FAQSection
        eyebrow="Location-Based FAQs"
        headline="Serving Your City — Questions Answered"
        faqs={locationFAQs}
      />

      <FinalCTASection
        headline="Serving Your Area — Let's Talk"
        subheadline="No matter where you are in Minnesota or the upper Midwest, Polished Concrete Plus will come to you. Call 320.493.1454 or fill out the form for a free on-site estimate."
        backgroundImage="https://readdy.ai/api/search-image?query=modern%20elegant%20commercial%20space%20polished%20concrete%20floor%20open%20plan%20warm%20evening%20interior%20lighting%20architectural%20photography%20premium%20quality%20atmospheric%20mood%20beautiful%20design&width=1920&height=1080&seq=loccta01&orientation=landscape"
      />

      <Footer />
    </main>
  );
}
